import React from 'react';
import PropTypes from 'prop-types';
import Title from '../../commonComponents/Title';
import SubHeader from '../../commonComponents/pageLayout/SubHeader';
import translate from '../../commonComponents/translate';
import ContentContainer from '../../commonComponents/pageLayout/ContentContainer';
import TopicBanner from '../../commonComponents/pageLayout/header/TopicBanner';
import SessionCreateEdit from './SessionCreateEdit';
import CountryProp from '../../commonComponents/forms/Address/CountryProp';
import HardSkillProp from '../challenges/propTypes/hardSkillProp';

function SessionCreateEditWrapper(props) {
  const {
    t,
    isEdit,
    languages,
    hardSkills,
  } = props;

  const title = isEdit ? t('edit_access_session') : t('add_access_session');

  return (
    <Title title={title}>
      <ContentContainer>
        <SubHeader title={title} />
        <TopicBanner />
        <div className="m-content">
          <div className="row full-page-container-with-subheader">
            <div className="col-lg-12">
              <SessionCreateEdit
                {...props}
                languages={languages}
                hardSkills={hardSkills}
              />
            </div>
          </div>
        </div>
      </ContentContainer>
    </Title>
  );
}

SessionCreateEditWrapper.propTypes = {
  /** Translation function */
  t: PropTypes.func.isRequired,
  isEdit: PropTypes.bool.isRequired,
  languages: PropTypes.arrayOf(PropTypes.shape(CountryProp.propType))
    .isRequired,
  hardSkills: PropTypes.arrayOf(PropTypes.shape(HardSkillProp.propType))
    .isRequired,
};

export default translate(SessionCreateEditWrapper);
